import { FieldDefinition, FieldBuilder } from '@zendra/shared';
import { StandTransformationHistoryService } from '../proxy/geographic/controllers';
import { RotationProjectionPlanningOrchestratorService } from 'orchestrator';

FieldBuilder.setNamespace('Geographic');

export const STANDTRANSFORMATIONHISTORYDETAIL_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .number('area', 'Entity.StandTransformationHistoryDetail.Area')
    .required()
    .decimal()
    .build(),
  FieldBuilder
    .number('areaPercentage', 'Entity.StandTransformationHistoryDetail.AreaPercentage')
    .required()
    .decimal()
    .build(),
  FieldBuilder.foreignKey(
    'standTransformationHistoryId',
    'Entity.StandTransformationHistoryDetail.StandTransformationHistory',
    StandTransformationHistoryService
  )
    .displayFromNested('standTransformationHistory.name')
    .sortBy('standTransformationHistory.name')
    .build(),
  FieldBuilder.foreignKey(
    'rotationId',
    'Entity.Rotation',
    RotationProjectionPlanningOrchestratorService
  )
    .required()
    .display('rotationDisplay')
    .displayFromNested('rotation.name')
    .sortBy('rotation.name')
    .build(),
  FieldBuilder
    .checkbox('isFinal', 'Entity.StandTransformationHistoryDetail.IsFinal')
    .build(),
];

export const STANDTRANSFORMATIONHISTORYDETAIL_CONFIG = {
  entityName: 'StandTransformationHistoryDetail',
  localizationKey: 'Geographic::Entity.StandTransformationHistoryDetail',
  fields: STANDTRANSFORMATIONHISTORYDETAIL_FIELDS,
  permission: 'PlanningGeography.StandTransformationHistoryDetails',
  showInMenu: false,
  menuCategory: '',
  menuSubcategory: '',
};
